import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";

const BranchOffice = () => {
    const location = useLocation();
    const [title, setTitle] = useState("")
  
  useEffect(()=>{
    let currentPath = location.pathname;
    currentPath = currentPath.split("/")[1]

    setTitle(currentPath);
  },[])

  return (
    <React.Fragment>
      <HeaderMobile/>
        <Breadcrumb heading={title} bTitle={title}/>
      <Container className="galleryRow ">
     
        <div>
            <h3>Coming Soon...</h3>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default BranchOffice;
